export default __webpack_public_path__ + "static/media/aiTriad.decba3d2.png";